module.exports = __webpack_public_path__ + "static/media/_Hebrock_brochure_top2000plus_en.0b6dc3aa.pdf";